import { IconElement } from '@backstage/frontend-plugin-api';
import AlarmIcon from '@material-ui/icons/Alarm';
import DigitalUnitIcon from '@material-ui/icons/Domain';
import { DigitalDomainIcon } from '@ingka/allen-core-components';
import { IconComponent, iconMapping } from '@ingka/plugin-ingka';

type IconName = keyof typeof iconMapping;

// Expose every iconMapping icon as a system icon, so it renders the same everywhere
const allenIcons: Record<string, IconElement> = Object.fromEntries(
  (Object.keys(iconMapping) as IconName[]).map(name => [
    name,
    <IconComponent icon={name} />,
  ]),
);

export const customSystemIcons: Record<string, IconElement> = {
  ...allenIcons,
  alert: <AlarmIcon fontSize="inherit" />,
  digitaldomain: <DigitalDomainIcon fontSize="inherit" />,
  digitalunit: <DigitalUnitIcon fontSize="inherit" />,
};
